import PropTypes from "prop-types";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import ProductGridTwo from "./ProductGridTwo";
import ProductGridListSingle from "../../components/product/ProductGridListSingle";

const TabProductFive = ({
  block,
  category,
  productTabClass
}) => {
  const [dynamicLink, setDynamicLink] = useState('/shop?tag=Best+Seller')
  return (
    <div
      className={`product-area ${block.spaceTopClass ? block.spaceTopClass : ""} ${
        block.spaceBottomClass ? block.spaceBottomClass : ""
      }`}
      // style={{ marginTop: '30px' }}
    >
      <div className="container">
        <Tab.Container defaultActiveKey="bestSeller">
          <Nav
            variant="pills"
            className={`product-tab-list-2 mb-60 ${
              productTabClass ? productTabClass : ""
            }`}
          >
            <Nav.Item>
              <Nav.Link eventKey="newArrival" onSelect={() => setDynamicLink('shop?tag=New')}>
                <h4>New Arrivals</h4>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="bestSeller" onSelect={() => setDynamicLink('/shop?tag=Best+Seller')}>
                <h4>Best Sellers</h4>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="saleItems" onSelect={() => setDynamicLink('shop?tag=Featured')}>
                <h4>Featured Items</h4>
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content className="product-list-padding">
            <Tab.Pane eventKey="newArrival" >
              <div className="row">
                <ProductGridTwo
                  category={category}
                  type="new"
                  limit={8}
                  spaceBottomClass="mb-25"
                />
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="bestSeller">
              <div className="row">
                <ProductGridTwo
                  category={category}
                  type="bestSeller"
                  limit={8}
                  spaceBottomClass="mb-25"
                />
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="saleItems">
              <div className="row">
                <ProductGridTwo
                  category={category}
                  type="saleItems"
                  limit={8}
                  spaceBottomClass="mb-25"
                />
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
        <div className="view-more text-center mt-20 toggle-btn6 col-12" style={{ marginBottom: '30px' }}>
          <Link
            className="loadMore6"
            to={process.env.PUBLIC_URL + dynamicLink}
          >
            VIEW MORE PRODUCTS
          </Link>
        </div>
      </div>
    </div>
  );
};

TabProductFive.propTypes = {
  category: PropTypes.string,
  productTabClass: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default TabProductFive;
